/**
 * GENERAL
 */
export const ONBOARDING_GUIDE_ID = '7eb7aed7-f816-42fb-a89e-86afb81e62c5'

export const RELATIONPICKER_GUIDE_ID = '2e38d56e-b927-4234-adff-a16bc58f51ea'

export const SUBMENU_GUIDE_ID = '802b39a1-9cf0-4d23-97d6-771302ba799b'

/**
 * ECONOMY
 */
export const INVOICE_LIST_GUIDE_ID = '80dd3417-5b4e-4419-931d-4255e6e6f218'
export const INVOICE_ARCHIVE_GUIDE_ID = '3d55cbee-ea63-48c3-a645-51c6c6a1b7ed'
export const INVOICE_LIST_APPROVE_GUIDE_ID =
  'c67a837b-b355-4852-b250-2e186e16f986'

export const INVOICE_SUPPLIER_INFO_GUIDE_ID =
  '71fa5ca7-1e6d-4c2c-9b90-ab9618ffd7f3'
export const INVOICE_PREVIOUS_GUIDE_ID = 'c4ef7715-afd0-4919-96b7-e5ad9434a100'
export const INVOICE_ALL_INFO_GUIDE_ID = '72cdadc6-475c-40b2-b99f-0eb858b3d654'
export const INVOICE_VIEW_ATTACHMENT_GUIDE_ID =
  '1c4b5c47-7e3f-43f0-afa9-db0ab952e6e1'

/**
 * HOUSINGASSOCIATION
 */
export const UNIT_NOTES_ADD_GUIDE_ID = 'c8e5d5d6-8028-4424-ab6b-004732618656'

export const UNIT_LIST_ADDRESS_GUIDE_ID = '9b668186-7962-4fdd-9bc2-ea5066797d9a'
export const UNIT_LIST_EXTRA_INFO_GUIDE_ID =
  '57c882a0-a2e5-46dc-b339-8669105f1ad4'
export const UNIT_LIST_NOTEICON_GUIDE_ID =
  'c03db251-acf2-4c03-bc4b-5e4058e97493'
export const UNIT_LIST_SUBLEASE_TAG_GUIDE_ID =
  '3f314629-7c75-455a-ac14-3c9ea6e22f1a'

export const SUBLEASE_LIST_GUIDE_ID = '109cac47-dee7-4215-8546-efc04a855d4c'

export const SUBLEASE_OVERRIDE_ENDDATE_GUIDE_ID =
  'c4a93f38-d77f-44db-9ebe-defc2d35c186'
export const SUBLEASE_HISTORY_GUIDE_ID = 'd241e3c0-6ca5-4857-a6f6-1d892cfa5ee2'

export const INSURANCE_LIST_GUIDE_ID = 'f681a964-e5f7-4ed8-b978-c24a60e9075d'

export const BOARD_AND_COMMITTES_GUIDE_ID =
  '2216fcb1-6ecb-42e7-9113-0aba4159bec5'

/**
 * COMMUNICATION
 * Communication guides are prefixed with "3338e2a8" for easier guide deletion
 */
export const COMMUNICATION_GUIDE_ID = '3338e2a8-2ebc-41e6-8c88-bfd5b3c69bf3'
export const PORTALUSER_MENUITEM_GUIDE_ID =
  '3338e2a8-7a64-456b-91ae-3102d7e8ba72'

export const CONTACTS_GUIDE_ID = '3338e2a8-33af-43d5-9ede-b61c338639ac'

export const INBOXSETTINGS_GUIDE_ID = '3338e2a8-ff04-4c85-9b8a-d2680cb4c1e9'

export const NOTICE_LIST_GUIDE_ID = '3338e2a8-bbb7-42db-a6f9-07bea34a57e5'

export const MANAGE_NOTICE_GUIDE_ID = '3338e2a8-cca1-4dbc-82f9-8b0ec3b81d9a'
export const MANAGE_NOTICE_ALERTS_GUIDE_ID =
  '3338e2a8-a5b4-402d-a3b9-6384b84fe08b'

export const EMAIL_COMMON_GUIDE_ID = '3338e2a8-643c-40cf-8047-619d67aef367'
export const MARK_EMAIL_GUIDE_ID = '3338e2a8-1664-43c4-a19b-2956f78c3eeb'
export const EMAIL_OPTIONS_GUIDE_ID = '3338e2a8-4319-43f8-b160-de4fe4fd5d16'
export const EMAIL_ATTACHMENTS_GUIDE_ID = '3338e2a8-035c-4034-8b16-f01bb19c79ff'
export const EMAIL_LABELS_GUIDE_ID = '3338e2a8-6661-4a6c-9555-7e4f39bd9e61'
export const EMAIL_PROCESSEDTAGS_GUIDE_ID =
  '3338e2a8-cb8d-4804-9e09-187f51abe9ad'

export const SMS_COMMON_GUIDE_ID = '3338e2a8-d471-4f6d-a864-45cf34b97e59'
export const MARK_SMS_GUIDE_ID = '3338e2a8-400e-471b-8eb2-7ca4bfdcdde6'
export const SMS_OPTIONS_GUIDE_ID = '3338e2a8-d785-477d-b12a-ab94cd7fd806'

/**
 * BOARDMEETINGS
 * Boardmeeting guides are prefixed with "8b93f1d1" for easier guide deletion
 */
export const BOARDMEETING_TABS = '8b93f1d1-93ec-44f1-9913-2a56767dab8b'
export const BOARDMEETING_SEARCH = '8b93f1d1-3501-4909-baed-8a6d3bfab988'

export const BOARDMEETING_LIST_GENERAL = '8b93f1d1-e863-483c-b549-43fe38eca3e3'
export const BOARDMEETING_LIST_ACTIONS = '8b93f1d1-12d2-4d37-b779-33b13c080b80'

export const BOARDMEETING_CASELIST_GENERAL =
  '8b93f1d1-416f-42d9-91d7-1499017e4cf2'
export const BOARDMEETING_CASELISTITEM = '8b93f1d1-415f-4d04-b035-39e2d2c541c9'

export const BOARDMEETING_CREATE = '8b93f1d1-78b6-43a2-a2e9-172a8a70585'

export const BOARDMEETING_DETAILS_COMMON =
  '8b93f1d1-e680-48e0-b3c6-6ffbce7737c0'
export const BOARDMEETING_DETAILS_AGENDA =
  '8b93f1d1-f1a5-4a9d-9549-5613bdbf0be2'
export const BOARDMEETING_DETAILS_OPEN_CASE =
  '8b93f1d1-cf35-4fa4-accc-176f313bc811'
export const BOARDMEETING_DETAILS_NEWMEETING =
  '8b93f1d1-74ba-4271-81d0-2c0eed1d00cb'
export const BOARDMEETING_DETAILS_COMPLETE =
  '8b93f1d1-6bfe-4db5-b3ca-2f8f517f1d79'
export const BOARDMEETING_DETAILS_COMPLETED =
  '8b93f1d1-2b8c-484f-9b49-7034226660fc'

export const BOARDMEETING_COMPLETE_SHARE_PROTOCOL =
  '8b93f1d1-1fa9-41ba-b05b-d9f90ca791ae'

/**
 * MESSAGES
 */
export const MESSAGES_COMMON_GUIDE_ID = 'be21883a-28e5-4296-9b2a-6fdbc724f930'
export const MESSAGES_ACTIONS_GUIDE_ID = 'be21883a-aaa8-4c53-b57a-92f413ade683'

/**
 * SKIP ALL GUIDES
 */
export const SKIP_ALL_GUIDES = '4927ec53-98dc-41d2-b5ea-1eae22af5abb'
